export const OnBoarding = {
    path: '/on_boardings',
    name: 'on_boardings',
    component: () => import('@/views/Boarding/OnBoardings.vue'),
    children: [
        {
            path: '/on_boardings/add',
            name: 'on_boardings.add',
            component: () => import('@/views/Boarding/Form/OnBoardingForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/on_boardings/edit/:id',
            name: 'on_boardings.edit',
            component: () => import('@/views/Boarding/Form/OnBoardingForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/on_boardings/delete/:id',
            name: 'on_boardings.delete',
            component: () => import('@/views/Boarding/Form/OnBoardingForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/on_boardings/view/:id',
            name: 'on_boardings.view',
            component: () => import('@/views/Boarding/Form/OnBoardingForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/on_boardings/documents/:id',
            name: 'on_boardings.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "ON_BOARDING"}
        },
        {
            path: '/on_boardings/template_applications/:id',
            name: 'on_boardings.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "ON_BOARDING"}
        },
    ],
}